var FIGURE = FIGURE || {};

FIGURE.navSubmenu = function() {
    document.querySelectorAll('.has-submenu').forEach(function(item) {
        var trigger = item.querySelector('a[aria-haspopup]');
        var popover = item.querySelector('.submenu[popover]');
        if (!trigger || !popover) return;

        var timer;

        function show() {
            clearTimeout(timer);
            if (!popover.matches(':popover-open')) {
                popover.showPopover();
                trigger.setAttribute('aria-expanded', 'true');
            }
        }

        function hide() {
            if (popover.matches(':popover-open')) {
                popover.hidePopover();
                trigger.setAttribute('aria-expanded', 'false');
            }
        }

        function scheduleHide() {
            clearTimeout(timer);
            timer = setTimeout(function() {
                // The popover's own open/close DOM mutation (display/pointer-events/top-layer
                // promotion) can make the browser recompute hover state under a stationary
                // cursor and fire a spurious mouseleave. Trust :hover, not the event stream,
                // before actually closing.
                if (item.matches(':hover') || popover.matches(':hover')) return;
                hide();
            }, 100);
        }

        // Hover: delay hide so the mouse can move from trigger into the popover
        item.addEventListener('mouseenter', show);
        item.addEventListener('mouseleave', scheduleHide);
        popover.addEventListener('mouseenter', function() { clearTimeout(timer); });
        popover.addEventListener('mouseleave', scheduleHide);

        // Focus: show on focus of the parent link, hide when focus leaves both
        trigger.addEventListener('focus', show);

        function hideIfFocusLeft(e) {
            if (!item.contains(e.relatedTarget) && !popover.contains(e.relatedTarget)) {
                hide();
            }
        }

        item.addEventListener('focusout', hideIfFocusLeft);
        popover.addEventListener('focusout', hideIfFocusLeft);

        // Escape key closes the submenu and returns focus to the trigger
        popover.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                hide();
                trigger.focus();
            }
        });
    });
}();
